import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonGroup, OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface Props {
  options: {
    icon: IconProp;
    label: string;
    value: string;
  }[];
  value: string;
  onChange: (value: string) => void;
}

export default function Toggle({ options, value, onChange }: Props) {
  return (
    <ButtonGroup aria-label="Toggle Map / Table View">
      {options.map(option => (
        <React.Fragment key={option.value}>
          <input
            checked={option.value === value}
            className="btn-check"
            id={option.value}
            name={option.value}
            type="radio"
            value={option.value}
            onChange={() => onChange(option.value)}
          />
          <OverlayTrigger overlay={<Tooltip>{option.label}</Tooltip>}>
            <label
              aria-label={option.label}
              className="btn btn-outline btn-icon"
              htmlFor={option.value}
            >
              <FontAwesomeIcon icon={option.icon} />
              <span className="visually-hidden">{option.label}</span>
            </label>
          </OverlayTrigger>
        </React.Fragment>
      ))}
    </ButtonGroup>
  );
}
